
export function vendedorError (state, payload){
    state.error = true
    state.errorMessage = payload
    state.isOK = false
}

export function setIsOk(state,payload){
    state.isOk = payload
}
export function setVentas(state,payload){
    state.ventas = payload.ventas.data
}
export function setId(state,payload){
    state.folio = payload.id
}
export function setOslp(state,payload){
    state.oslp = payload.data.oslp
}